import _fp from 'lodash/fp';
import React from 'react';
import { Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import ActiveStatusModal from '../components/ActiveStatusModal/ActiveStatusModal';
import api from '../services';

/**
 * Status pill for a table cell. The detail-page headers show the same state as a
 * `components/StatusRibbon` along the card's top edge instead.
 */
export const activeStatusIconAndText = (row) => {
  if (row.id) {
    return <Chip size='small' color={row.active ? 'success' : 'error'} label={row.active ? 'Active' : 'Inactive'} />;
  }
};

const updateStatus = (row, activeStatus, endpoint) => {
  if (row.id) {
    let isActive = activeStatus;
    const zuulUser = JSON.parse(localStorage.getItem('userData'));
    let saveData = {
      id: row.id,
      isActive,
      active: activeStatus,
      zuulUser,
    };
    api.put(`${endpoint}/active/${row.id}`, saveData);
  }
};

export const activeStatusSwitch = (row, entity, errors) => {
  return (
    <ActiveStatusModal
      content={row}
      isActive={row.active}
      modalType={entity.modalType}
      getErrors={() => errors || null}
      onClickSubmit={(activeStatus) => updateStatus(row, activeStatus, entity.endpoint)}
    />
  );
};

/**
 * The switch is deliberately not offered here: this wraps the cell in a Link, and a switch inside
 * one follows it on click instead of toggling. Render `activeStatusSwitch` in its own cell.
 */
export const columnFormatter = ({ cell, row, computedURL, activeStatusType }) => {
  let isReturnUrl = row.offerType === 'Return Url';
  if (isReturnUrl) {
    computedURL = false;
  }

  // The Row/Col this content used to sit in added Bootstrap gutters inside a table cell and nothing
  // else; the `inherit-color` class it carried is defined by no stylesheet in the built output.
  return (
    <Link to={computedURL} style={{ textDecoration: 'none', color: 'inherit' }}>
      {activeStatusType === 'iconAndText' ? activeStatusIconAndText(row) : cell}
    </Link>
  );
};

/**
 * Functional way to test regex that works with lodash/fp.
 * Takes you regex and text and returns a boolean if the text matches the regex.
 *
 * @param regexp
 * @returns {function(*=): *}
 */
export const testRegex = (regexp) => (text) => regexp.test(text);

/**
 * Filters entities to support search in entity tables.
 * Takes a list of entities, a function that transforms the entity into a list of terms to compare against the search
 * term, and the search term.
 *
 * Example entity transforming function:
 * (entity) => ([entity.id, entity.name, entity.status])
 *
 * @param entities
 * @param transformEntityForSearching
 * @param searchTerm
 * @returns {any[]|*}
 */
export const filterForSearch = (transformEntityForSearching, searchTerm) => (entities) => {
  if (searchTerm && entities.length > 0) {
    const likeSearchRegexp = new RegExp(`.*${_fp.toLower(searchTerm)}.*`);
    const mapLower = _fp.map(_fp.toLower);
    const regexpMatchesSome = _fp.some(testRegex(likeSearchRegexp));
    const searchTermIsInAnyValue = _fp.pipe(transformEntityForSearching, mapLower, regexpMatchesSome);

    return _fp.filter(searchTermIsInAnyValue)(entities);
  } else {
    return entities;
  }
};
export const filterDataBySearchTerm = (searchTerm, keysToSearchBy, unfilteredData) => {
  // Split the term by space and remove empty spaces
  let splitSearchTerm = searchTerm.split(/[ ,]+/).filter(Boolean);
  const filteredData = unfilteredData.filter((entity) => {
    const entityToSearchBy = {};
    keysToSearchBy.forEach((key) => {
      // WIP entity[key] could be an object i.e. site = {}
      entityToSearchBy[key] = entity[key] + '' || '';
      if (entity[key] && typeof entity[key] === 'object' && entity[key].name) {
        entityToSearchBy[key] = entity[key].name + '' || '';
      }
    });
    let doesMatchTerms = true;
    for (let i = 0; i < splitSearchTerm.length; i++) {
      if (
        !Object.keys(entityToSearchBy).some((key) =>
          entityToSearchBy[key].toLowerCase().includes(splitSearchTerm[i].toLowerCase())
        )
      ) {
        doesMatchTerms = false;
      }
    }
    return doesMatchTerms;
  });
  return filteredData;
};
